/**
 * AI Analysis Hook
 *
 * React Query hook for analyzing evaluation input with AI.
 */

import { useMutation } from '@tanstack/react-query';
import { apiRequest } from '../../../../lib/api';
import type { AIAnalysisResult, AIAnalyzeRequest } from '@functieloonhuis/shared';

/**
 * Hook to analyze evaluation input with AI
 */
export function useAIAnalysis(evaluationId: number) {
  return useMutation({
    mutationFn: async (input: string) => {
      const request: AIAnalyzeRequest = { input };
      return apiRequest<AIAnalysisResult>(`/evaluations/${evaluationId}/ai-analyze`, {
        method: 'POST',
        body: JSON.stringify(request),
      });
    },
  });
}
